<template>
  <form
    class="form-sheet"
    @submit.prevent="$emit('submit')"
  >
    <slot />
  </form>
</template>

<script setup>
defineEmits(['submit']);
</script>

<style scoped>
.form-sheet {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
